import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeoToDocument, getSeo } from '../seo';

const Seo = ({ initialData = null }) => {
    const location = useLocation();

    useEffect(() => {
        applySeoToDocument(getSeo(location.pathname, initialData));
    }, [initialData, location.pathname]);

    return null;
};

export default Seo;
